<div class="modal-header">
    <h4 class="modal-title pull-left">Projectfase </h4>
    <button aria-label="Close" class="close pull-right" mat-dialog-close="" tabindex="-1" type="button">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div *ngIf="form" [formGroup]="form" class="modal-body">
    <mat-form-field class="w-100">
        <mat-placeholder>Naam</mat-placeholder>
        <input formControlName="name" matInput type="text">
        <mat-error [control]="fc.name"></mat-error>
    </mat-form-field>
    <mat-form-field (click)="start_date.open()" class="w-100">
        <mat-label>Datum uitvoering</mat-label>
        <input [formControl]="fc.start_date" [matDatepicker]="start_date" matInput>
        <mat-datepicker-toggle [for]="start_date" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #start_date></mat-datepicker>
        <mat-error [control]="fc.start_date"></mat-error>
    </mat-form-field>
    <mat-form-field (click)="end_date.open()" class="w-100">
        <mat-label>Datum uitgevoerd</mat-label>
        <input [formControl]="fc.end_date" [matDatepicker]="end_date" matInput>
        <mat-datepicker-toggle [for]="end_date" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #end_date></mat-datepicker>
        <mat-error [control]="fc.end_date"></mat-error>
    </mat-form-field>
    <div *ngIf="!projectPhase.done">
        <button color="primary" mat-button (click)="setActive()">
            Instellen als actieve fase
        </button>
        <button color="primary" mat-button (click)="isDone(true)">
            markeren als gereed
        </button>
    </div>
    <div *ngIf="projectPhase.done">
        <button color="warn" mat-button (click)="isDone(false)">
            markeren als niet gereed
        </button>
    </div>
</div>
<div class="modal-footer">
    <button (click)="delete()" *ngIf="projectPhase.id" color="warn" mat-button>
        Verwijderen
    </button>
    <div class="flex-fill"></div>
    <button color="primary" mat-button mat-dialog-close="" type="button">
        Sluiten
    </button>
    <button (click)="save()" [disabled]="form.invalid || saving" color="primary" mat-raised-button type="button">
        Opslaan <i *ngIf="saving" class="fas fa-circle-notch fa-spin"></i>
    </button>
</div>
